import React, { useState } from 'react';
import axios from 'axios';
import './AIAssistant.css';

function AIAssistant({ onClose }) {
  const [question, setQuestion] = useState('');
  const [loading, setLoading] = useState(false);
  const [conversation, setConversation] = useState([]);

  const handleAsk = async () => {
    if (!question.trim()) return;

    setLoading(true);
    const userMessage = { type: 'user', text: question };
    setConversation([...conversation, userMessage]);
    setQuestion('');

    try {
      const result = await axios.post('/api/ai/ask', { question });
      
      const aiMessage = { type: 'ai', text: result.data.response };
      setConversation(prev => [...prev, aiMessage]);

      if (result.data.performedActions && result.data.performedActions.length > 0) {
        const summaryText = result.data.performedActions
          .map(action => {
            if (action.type === 'send') {
              return `sent email to ${action.to}`;
            }
            return `${action.type} (${action.count})`;
          })
          .join(', ');
        const summaryMessage = { type: 'ai', text: `✅ Actions applied: ${summaryText}` };
        setConversation(prev => [...prev, summaryMessage]);
      }
    } catch (error) {
      console.error('AI error:', error);
      let errorText = 'Sorry, I encountered an error. Please try again.';
      if (error.response?.data?.message) {
        errorText = `Error: ${error.response.data.message}`;
      } else if (error.response?.status === 401) {
        errorText = 'Please log in again to use the AI assistant.';
      }
      const errorMessage = { type: 'error', text: errorText };
      setConversation(prev => [...prev, errorMessage]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleAsk();
    }
  };

  return (
    <div className="ai-assistant-modal">
      <div className="ai-assistant-container">
        <div className="ai-assistant-header">
          <h2>🤖 AI Email Assistant</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="ai-conversation">
          {conversation.length === 0 ? (
            <div className="ai-welcome">
              <p>👋 Hi! I'm your AI email assistant.</p>
              <p>Ask me to:</p>
              <ul>
                <li>Sort or organize your emails</li>
                <li>Delete spam emails</li>
                <li>Find specific emails</li>
                <li>Summarize important messages</li>
              </ul>
            </div>
          ) : (
            conversation.map((msg, idx) => (
              <div key={idx} className={`message ${msg.type}`}>
                <div className="message-content">{msg.text}</div>
              </div>
            ))
          )}
          {loading && (
            <div className="message ai">
              <div className="message-content typing">
                <span></span><span></span><span></span>
              </div>
            </div>
          )}
        </div>

        <div className="ai-input-container">
          <textarea
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Ask me anything about your emails..."
            rows="5"
          />
          <button 
            onClick={handleAsk} 
            disabled={loading || !question.trim()}
            className="send-btn"
          >
            {loading ? '⏳' : '📤'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AIAssistant;
